import { render, staticRenderFns } from "./GeneratePublicKeyDexIdModal.vue?vue&type=template&id=c7db2c5e&scoped=true"
import script from "./GeneratePublicKeyDexIdModal.vue?vue&type=script&lang=ts"
export * from "./GeneratePublicKeyDexIdModal.vue?vue&type=script&lang=ts"
import style0 from "./GeneratePublicKeyDexIdModal.vue?vue&type=style&index=0&id=c7db2c5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7db2c5e",
  null
  
)

export default component.exports